module.exports = __webpack_public_path__ + "static/img/guanbihuiyi.bcd1949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/guanbihuiyi.png
// module id = lBkt
// module chunks = 24